export const CategoryV2Slug = {
  ACCOUNT_BASED_MARKETING: 'abm',
  ACCOUNTING: 'accounting',
  ADVERTISING: 'advertising',
  APPLICANT_TRACKING_SYSTEMS: 'applicant-tracking-systems',
  CALLING: 'calling',
  COLLABORATION: 'collaboration',
  COMPETITIVE_INTELLIGENCE: 'competitive-intelligence',
  CONNECTOR: 'connector',
  CONSENT_MANAGEMENT: 'consent-management',
  CONTENT_MANAGEMENT_SYSTEM: 'cms',
  CONVERSATION_INTELLIGENCE: 'conversation-intelligence',
  CPQ: 'cpq',
  CRM: 'crm',
  CUSTOMER_SUCCESS: 'customer-success',
  DATA_MIGRATION: 'data-migration',
  DATA_QUALITY_BACKUP: 'data-quality-backup',
  DIGITAL_PLATFORM_ADOPTION: 'digital-platform-adoption',
  DIRECT_MAIL_AUTOMATION: 'direct-mail-automation',
  E_COMMERCE: 'ecommerce',
  E_SIGNATURE: 'esignature',
  EMAIL: 'email',
  ERP: 'erp',
  ETL: 'etl',
  EVENT_MANAGEMENT: 'event-management',
  EXPERIENCE_MANAGEMENT: 'experience-management',
  FIELD_SERVICE: 'field-service',
  FORM_BUILDER: 'form-builder',
  FUNDRAISING_NON_PROFIT: 'nonprofit',
  HELP_DESK: 'help-desk',
  IPAAS: 'ipaas',
  KNOWLEDGE_BASE: 'knowledge-base',
  LEAD_SCORING_ROUTING: 'lead-scoring-routing',
  LEARNING_MANAGEMENT_SYSTEM: 'learning-management-system',
  LIVE_CHAT: 'live-chat',
  MARKETING_ANALYTICS: 'marketing-analytics',
  MARKETING_AUTOMATION: 'marketing-automation',
  MESSAGING_NETWORK: 'messaging-network',
  PARTNER_MANAGEMENT: 'partner-management',
  PAYMENTS: 'payments',
  PRODUCT_ANALYTICS: 'product-analytics',
  PROJECT_MANAGEMENT: 'project-management',
  PROPOSALS: 'proposals',
  SALES_ANALYTICS: 'sales-analytics',
  SALES_COMPENSATION: 'sales-compensation',
  SALES_ENABLEMENT: 'sales-enablement',
  SALES_ENGAGEMENT: 'sales-engagement',
  SALES_INTELLIGENCE: 'sales-intelligence',
  SCHEDULING: 'scheduling',
  SENSITIVE_DATA: 'sensitive-data',
  SEO: 'seo',
  SESSION_REPLAYS: 'session-replays',
  SMS: 'sms',
  SOCIAL_MEDIA_MANAGEMENT: 'social-media-management',
  SOCIAL_NETWORKS: 'social-networks',
  SPREADSHEETS: 'spreadsheets',
  SUBSCRIPTION_MANAGEMENT: 'subscription-management',
  SURVEYS: 'surveys',
  TICKETING: 'ticketing',
  VIDEO: 'video',
  WEBINARS: 'webinars',
  WORKFLOW_AUTOMATION: 'workflow-automation',
  WORKFORCE_MANAGEMENT: 'workforce-management'
};